// Relation type configuration
// ---------------------------
// Other relation types that point to STAC entities and should be shown in STAC
// Browser instead of opening them raw in a new tab.
export const stacNavigation = [];
// Relation types that should be hidden from the link list in STAC Browser.
export const hidden = [];
